function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import queryString from 'qs';
import { storageFactory } from '@domain-group/fe-helper';
import { WebserviceError } from './exceptions';
var storage = storageFactory({
  name: 'allhomes-api'
});
var USER_IDENTITY_KEY = 'user-identity';
var formBody = data => Object.keys(data).map(key => "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(data[key]))).join('&');
var TYPE = {
  json: {
    contentType: 'application/json',
    body: JSON.stringify
  },
  form: {
    contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
    body: formBody
  },
  empty: {
    contentType: null,
    body: data => data
  }
};
var ANONYMOUS = {
  user: {
    type: 'anonymous'
  },
  data: {}
};
var RETRY_CODES = ['expired', 'identity_required', 'authentication_required'];
var shouldRetry = error => error instanceof WebserviceError && RETRY_CODES.includes(error.errorCode);
var basicFetch = (endpoint, data, _ref) => {
  var method = _ref.method,
    isProduction = _ref.isProduction,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'json' : _ref$type,
    _ref$blob = _ref.blob,
    blob = _ref$blob === void 0 ? false : _ref$blob;
  var requestType = TYPE[type] || TYPE.empty;
  return fetch(endpoint, _objectSpread({
    method: method || 'POST',
    headers: _objectSpread({}, requestType.contentType && {
      'Content-Type': requestType.contentType
    }),
    credentials: isProduction ? 'same-origin' : 'include'
  }, method !== 'GET' && {
    body: requestType.body(data)
  })).then(response => {
    var contentType = response.headers.get('content-type');
    var isJson = contentType && contentType.startsWith(TYPE.json.contentType);
    if (response.ok) {
      if (blob) {
        return response.blob();
      }
      if (isJson) {
        return response.json();
      }
      return response.body;
    }
    var errorResponse = {
      error: response.status,
      message: response.statusText
    };
    if (isJson) {
      return response.json().then(content => {
        throw new WebserviceError(_objectSpread(_objectSpread({}, errorResponse), content));
      });
    }
    throw new WebserviceError(errorResponse);
  });
};
var apiClient = function apiClient() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    identityEndpoint = _ref2.identityEndpoint,
    signOutEndpoint = _ref2.signOutEndpoint,
    _ref2$isProduction = _ref2.isProduction,
    isProduction = _ref2$isProduction === void 0 ? true : _ref2$isProduction,
    additionalData = _ref2.additionalData,
    _ref2$onRefreshIdenti = _ref2.onRefreshIdentity,
    onRefreshIdentity = _ref2$onRefreshIdenti === void 0 ? () => {} : _ref2$onRefreshIdenti;
  var tokenPromise = Promise.resolve(null);
  var getToken = () => tokenPromise;
  var setIdentityPromise = identityPromise => {
    tokenPromise = identityPromise.then(_ref3 => {
      var token = _ref3.token;
      return token;
    });
    identityPromise.then(response => {
      storage.setItem(USER_IDENTITY_KEY, response);
      onRefreshIdentity(response);
    });
    return identityPromise;
  };
  var setIdentity = identity => setIdentityPromise(Promise.resolve(identity));
  var initialUser = storage.getItem(USER_IDENTITY_KEY);
  if (initialUser) {
    setIdentity(initialUser);
  }
  var refreshIdentity = identityRequired => setIdentityPromise(basicFetch("".concat(identityEndpoint, "?").concat(queryString.stringify({
    identityRequired,
    additionalData
  }, {
    arrayFormat: 'repeat'
  })), null, {
    isProduction,
    type: 'empty'
  }).catch(() => ANONYMOUS));
  var terminate = () => getToken().then(token => basicFetch("".concat(signOutEndpoint, "?").concat(queryString.stringify({
    token
  })), null, {
    isProduction,
    type: 'empty'
  })).then(() => setIdentity(ANONYMOUS));
  var withRetry = func => func().catch(error => {
    if (shouldRetry(error)) {
      return refreshIdentity(true).then(() => func());
    }
    throw error;
  });
  var post = (endpoint, payload, options) => basicFetch(endpoint, payload, _objectSpread(_objectSpread({}, options), {}, {
    method: 'POST'
  }));
  var get = (endpoint, options) => basicFetch(endpoint, null, _objectSpread(_objectSpread({}, options), {}, {
    method: 'GET',
    type: 'empty'
  }));
  var postWithToken = (endpoint, payload, options) => withRetry(() => getToken().then(token => post(endpoint, _objectSpread(_objectSpread({}, payload), {}, {
    token
  }), options)));
  return {
    get,
    post,
    postWithToken,
    refreshIdentity,
    setIdentity,
    terminate
  };
};
export default apiClient;